<section class="py-7">
  @if (filters(); as filters) {
    <div class="desk:centered-with-padding no-scrollbar flex w-screen overflow-x-auto px-5 pb-7">
      <app-filter-toggle-group [filterName]="filterName" [filters]="filters" />
    </div>
  }

  @if (packs(); as packs) {
    @if (data.productPackType === "appliances") {
      <div class="desk:centered-with-padding grid grid-cols-1 gap-y-9">
        @for (pack of packs; track $index) {
          @let responsiveRecap = breakpoints() === "mobile" ? stackedTemplate : sidebySideTemplate;
          <ng-container
            *ngTemplateOutlet="responsiveRecap; context: { pack, products: pack!.products, isCompact: false }" />
        }
      </div>
    } @else if (data.productPackType === "sinkAndTap") {
      <div class="desk:centered-with-padding grid grid-cols-1 gap-x-5 gap-y-9 desk:grid-cols-2">
        @for (pack of packs; track $index) {
          <ng-container
            *ngTemplateOutlet="stackedTemplate; context: { pack, products: pack!.products, isCompact: true }" />
        }
      </div>
    }
  } @else {
    <app-grid-skeleton
      [gridClass]="
        data.productPackType === 'sinkAndTap'
          ? 'desk:centered-with-padding grid grid-cols-1 gap-x-5 gap-y-9 desk:grid-cols-2'
          : 'desk:centered-with-padding grid grid-cols-1 gap-y-9'
      "
      itemClass="h-[260px]"
      [count]="2" />
  }

  <ng-template #stackedTemplate let-isCompact="isCompact" let-pack="pack" let-products="products">
    @let productsLength = products.length;
    <div class="flex flex-col">
      <div class="no-scrollbar flex-1 overflow-x-scroll px-5 desk:px-0">
        <div class="h-full w-fit rounded-3xl rounded-bl-none bg-gray-light px-5 pb-7 pt-9 desk:w-full">
          <div
            [class.grid-cols-[225px]]="productsLength === 1 && isCompact"
            [class.grid-cols-[225px_225px]]="productsLength === 2 && isCompact"
            [class.grid-cols-[250px]]="productsLength === 1 && !isCompact"
            [class.grid-cols-[250px_250px]]="productsLength === 2 && !isCompact"
            [class.grid-cols-[250px_250px_250px]]="productsLength === 3 && !isCompact"
            [class.grid-cols-[250px_250px_250px_250px]]="productsLength === 4 && !isCompact"
            class="grid h-full gap-x-10">
            <ng-container *ngTemplateOutlet="productShowcaseTemplate; context: { products, isCompact }" />
          </div>
        </div>
      </div>
      <div class="px-5 desk:px-0">
        <div class="w-fit min-w-[280px] max-w-full rounded-b-3xl bg-anis px-6 py-5">
          <ng-container *ngTemplateOutlet="bundlePriceTemplate; context: { pack, isCompact }" />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #sidebySideTemplate let-pack="pack" let-products="products">
    @let productsLength = products.length;
    <div class="relative flex">
      <div class="relative max-w-[calc(100%-190px)]">
        <div>
          <div class="h-full rounded-l-3xl bg-gray-light px-5 pb-7 pt-9 desk:w-full">
            <div #slidesElementRef class="no-scrollbar overflow-x-scroll scroll-smooth">
              <div
                [class.grid-cols-[250px]]="productsLength === 1"
                [class.grid-cols-[250px_250px]]="productsLength === 2"
                [class.grid-cols-[250px_250px_250px]]="productsLength === 3"
                [class.grid-cols-[250px_250px_250px_250px]]="productsLength === 4"
                class="grid h-full gap-x-10">
                <ng-container *ngTemplateOutlet="productShowcaseTemplate; context: { products }" />
              </div>
            </div>
          </div>
        </div>
        @if (products.length > 3) {
          @if (displayLeftButton) {
            <button
              (click)="moveSlider('prev', slidesElementRef)"
              class="drop-shadow-custom absolute left-4 top-[110px] flex size-9 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-xl bg-white">
              <app-svg [height]="24" [width]="24" class="block rotate-180" src="assets/icons/arrow-right.svg" />
            </button>
          }
          @if (displayRightButton) {
            <button
              (click)="moveSlider('next', slidesElementRef)"
              class="drop-shadow-custom absolute right-4 top-[110px] flex size-9 -translate-y-1/2 translate-x-1/2 items-center justify-center rounded-xl bg-white">
              <app-svg [height]="24" [width]="24" src="assets/icons/arrow-right.svg" />
            </button>
          }
        }
      </div>
      <div class="flex w-fit items-center rounded-r-3xl bg-anis p-4">
        <ng-container *ngTemplateOutlet="bundlePriceTemplate; context: { pack: pack }" />
      </div>
    </div>
  </ng-template>
</section>

<ng-template #productShowcaseTemplate let-isCompact="isCompact" let-products="products">
  @for (product of products; track product.id) {
    @let image = product.image;
    @let brandImage = product.brand.image;
    <div class="flex flex-col gap-2">
      <div class="grid h-[190px] grid-cols-1 items-end justify-center">
        <div class="relative size-full">
          <app-image [image]="image" [isPriority]="!isImageInPreviousBlocks && $index < 2" [keepAspectRatio]="true" />
          @if (!$last) {
            <div class="absolute inset-0">
              <div [class.ml-[222px]]="isCompact" [class.ml-[246px]]="!isCompact" class="flex size-full items-center">
                <app-svg [height]="46" [width]="46" src="assets/icons/plus.svg" />
              </div>
            </div>
          }
        </div>
      </div>
      @if (brandImage.link) {
        <div class="h-6">
          <app-image
            [image]="brandImage"
            [isPriority]="!isImageInPreviousBlocks && $index < 2"
            [keepAspectRatio]="true" />
        </div>
      }
      <div class="grid grid-cols-[auto_1fr] gap-x-5">
        <div class="flex flex-col">
          <span class="font-bold">{{ product.title }}</span>
          <span class="text-sm">{{ product.subtitle }}</span>
        </div>
        <div class="flex flex-col text-right">
          <span class="text-nowrap text-[18px] font-bold">{{ product.price }}</span>
          <span class="text-sm leading-none">
            {{ "GLOBAL.INCLUDING_X_ENVIRONMENTAL_TAX" | translate: { environmentalTaxPrice: product.ecopart } }}
          </span>
        </div>
      </div>
    </div>
  }
</ng-template>

<ng-template #bundlePriceTemplate let-isCompact="isCompact" let-pack="pack">
  <div
    [class.desk:gap-y-2.5]="!isCompact"
    [class.desk:grid-cols-1]="!isCompact"
    class="grid grid-cols-2 items-center justify-center desk:gap-y-2.5">
    <div class="flex flex-col">
      <div [class.desk:font-medium]="!isCompact" class="pb-2 font-normal">
        {{ "COMPONENT.LISTING-PACK-PRODUITS.FOR_THE_SET" | translate }}
      </div>
      <div class="text-nowrap pb-1.5 font-title desk:pb-2.5">
        <span class="text-[40px]">{{ pack.newPrice | replaceWholeWord: " €" : "" }}</span>
        <span [class.desk:text-[40px]]="!isCompact" class="text-[30px]"> €</span>
      </div>
      <div class="text-nowrap text-sm">
        {{ "GLOBAL.INCLUDING_X_ENVIRONMENTAL_TAX" | translate: { environmentalTaxPrice: pack.ecoPart } }}
      </div>
    </div>
    <div [class.desk:items-start]="!isCompact" class="flex flex-col items-center font-medium">
      <div>{{ "COMPONENT.LISTING-PACK-PRODUITS.INSTEAD_OF" | translate }}</div>
      <div
        [class.desk:font-medium]="!isCompact"
        [class.desk:text-[18px]]="!isCompact"
        class="relative inline-block text-nowrap text-[20px] font-normal text-black before:absolute before:inset-x-0 before:top-1/2 before:rotate-12 before:border-t-2 before:border-[current] before:content-['']">
        {{ pack.price }}
      </div>
    </div>
  </div>
</ng-template>
